import { StatusOptions } from '@/shared/utils/status';

import { DELETE, POST } from '@/front/fetch';
import { alertModal } from '@/front/modal';

export const modelId = () => (document.getElementById('modelId') as HTMLInputElement | null)?.value;

export const execute = async (method: typeof POST | typeof DELETE, action: string, data?: any) => {
  const res = await method(action, data);

  let status: StatusOptions | undefined;

  try {
    status = await res.json();
  } catch (error) {
    // No options - ignore
    console.info(error);
  }

  if (status?.message) {
    alertModal(status.message);
  }

  if (res.ok) {
    if (status?.redirectUrl) {
      window.location.href = status.redirectUrl;
    }
  }

  return { res, status };
};
